import { Dispatch, createContext, useState } from "react";
import {
  CompaniesStatisticsResponse,
  PaginatedCompanyResponse,
} from "../api/companyCollection.api";

type Props = {
  children: React.ReactNode;
};

interface CompaniesContextType {
  companyPage: PaginatedCompanyResponse | undefined;
  setCompanyPage: Dispatch<
    React.SetStateAction<PaginatedCompanyResponse | undefined>
  >;
  statistics: CompaniesStatisticsResponse | undefined;
  setStatistics: Dispatch<
    React.SetStateAction<CompaniesStatisticsResponse | undefined>
  >;
}

const defaultContext: CompaniesContextType = {
  companyPage: undefined,
  setCompanyPage: () => {},
  statistics: undefined,
  setStatistics: () => {},
};

export const CompaniesContext =
  createContext<CompaniesContextType>(defaultContext);

const CompaniesProvider: React.FunctionComponent<Props> = ({ children }) => {
  const [companyPage, setCompanyPage] = useState<
    PaginatedCompanyResponse | undefined
  >(undefined);
  const [statistics, setStatistics] = useState<
    CompaniesStatisticsResponse | undefined
  >(undefined);

  return (
    <CompaniesContext.Provider
      value={{
        companyPage,
        setCompanyPage,
        statistics,
        setStatistics,
      }}
    >
      {children}
    </CompaniesContext.Provider>
  );
};

export default CompaniesProvider;
